/** Restore invalidations add TC coverage without changing legacy mutations.
 * For Media Devoted | Created By Ciro Autiero */
import type { QueryClient } from "@tanstack/react-query";
import { matchTracker, type TrackerId } from "@trafficpulse/shared";
import { isTcRestoreBankKey } from "@/features/flow-optimizer/snapshots/restore-cache/tc-bank-cache";
const TC = "tres-commas";
export function invalidateTcRestoredBanks(
  client: QueryClient,
  provider: TrackerId,
): void {
  matchTracker(provider, {
    voluum: () => undefined,
    binom: () => undefined,
    "tres-commas": () => {
      void client.invalidateQueries({ queryKey: [TC, "flows"] });
      void client.invalidateQueries({ queryKey: [TC, "campaigns"] });
      void client.invalidateQueries({
        predicate: (q) => isTcRestoreBankKey(q.queryKey),
      });
    },
  });
}
export function invalidateTcCenterRestore(
  client: QueryClient,
  provider: TrackerId,
): void {
  matchTracker(provider, {
    voluum: () => undefined,
    binom: () => undefined,
    "tres-commas": () => {
      void client.invalidateQueries({ queryKey: [TC, "flow"] });
      for (const kind of ["queue", "rotation-history", "queue-events"])
        void client.invalidateQueries({
          queryKey: [TC, "flow-optimizer", kind],
        });
      invalidateTcRestoredBanks(client, provider);
    },
  });
}
